import styled from 'styled-components/macro';

const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.red};
  font-size: 10px;
  margin: 0;
`;

export default ErrorText;
